const ascii = `%c
                               dP       dP       oo             oo
                               88       88
             .d8888b. .d8888b. 88d888b. 88d888b. dP    .d8888b. dP
             88'  \`88 88'  \`88 88'  \`88 88'  \`88 88    88'  \`88 88
             88.  .88 88.  .88 88.  .88 88.  .88 88 dP 88.  .88 88
             \`8888P88 \`88888P8 88Y8888' 88Y8888' dP 88 \`88888P8 dP
                  .88
              d8888P

 ┌─────────────────────────────────────────────────────────────────────────────┐
 │                  Hi there dev! Any questions, please ask!                   │
 └─────────────────────────────────────────────────────────────────────────────┘`

export default ascii
